import { forwardRef, useImperativeHandle, useState } from "react";
import { isNameValid } from "../../helpers";
import { useFormContext, useFormState } from "react-hook-form";
import circularProgress from "../../public/assets/lottie/circularProgress.json";
import comet from "../../public/assets/onboarding/comet.svg";
import gulu from "../../public/assets/onboarding/gulu.svg";
import mars from "../../public/assets/onboarding/mars.svg";
import controlRoom from "../../public/assets/onboarding/control_room.svg";
import dynamic from "next/dynamic";
const Lottie = dynamic(() => import("lottie-react-web"), { ssr: false });
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Image from "next/image";
import { useBoardingFlow } from "../../hooks/useBoardingFlow";

function MyNameIsStep(props, ref) {
  const [isPending, setIsPending] = useState(false);
  const { formState, setError, setValue, watch } = useFormContext();
  const { setUserGradeAndName } = useBoardingFlow();

  const nameValue = watch("name");

  const setUserName = () => {
    if (!isNameValid(nameValue)) {
      return setError("name", {
        type: "manual",
        message: "Full Name is required.",
      });
    }

    setUserGradeAndName({
      setIsPending,
    });
  };

  useImperativeHandle(ref, () => ({
    reset: () => {
      setIsPending(false);
    },
  }));

  return (
    <div className="slide__page">
      <div className="fourth__page__inner">
        <div className="stars__background">
          <div className="stars"></div>
          <div className="twinkling"></div>
        </div>

        <div className="top__area">
          <h6>My name is</h6>
          {isPending ? (
            <button
              style={{
                visibility: isNameValid(nameValue) ? "visible" : "hidden",
                pointerEvents: isNameValid(nameValue) ? "auto" : "none",
              }}
              className="sending__otp"
            >
              <Lottie
                options={{
                  animationData: circularProgress,
                  loop: true,
                }}
              />
            </button>
          ) : (
            <button
              style={{
                visibility: isNameValid(nameValue) ? "visible" : "hidden",
                pointerEvents: isNameValid(nameValue) ? "auto" : "none",
              }}
              onClick={() => {
                setUserName();
              }}
              className={!isNameValid(nameValue) ? "disabled" : ""}
              disabled={!isNameValid(nameValue)}
            >
              <ArrowForwardIcon />
            </button>
          )}
        </div>
        <input
          placeholder="Type here..."
          autoComplete={"off"}
          className="full_name_input"
          type="text"
          name="full_name"
          value={nameValue}
          onChange={(e) => setValue("name", e.target.value)}
        />

        {formState.errors.name && (
          <div
            className="phone__error__message"
            style={{
              left: "5%",
              animation: "none",
              marginTop: "-38px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <ErrorOutlineIcon />
            {formState.errors.name.message as string}
          </div>
        )}

        <Image
          height={100}
          width={100}
          src={comet}
          alt="comet"
          className="comet"
        />
        <Image
          height={100}
          width={100}
          src={comet}
          alt="comet2"
          className="comet2"
        />

        <Image
          height={100}
          width={100}
          src={gulu}
          alt="gulu"
          className="gulu"
          draggable={false}
        />
        <Image
          height={100}
          width={100}
          src={mars}
          alt="mars"
          className="mars"
          draggable={false}
        />
        <Image
          height={100}
          width={100}
          src={controlRoom}
          alt="control"
          className="control"
          draggable={false}
        />
      </div>
    </div>
  );
}

export default forwardRef(MyNameIsStep);
